import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';

const LearningSection = () => {
    return (
        <Box sx={{ mt: 'var(--space-11)', mb: 'var(--space-10)', textAlign: 'center' }}>
            <Typography variant="h2" sx={{ fontSize: { xs: '1.5rem', sm: '1.8rem' }, fontWeight: 700, mb: 4, color: 'var(--fg)' }}>
                Learn More About JSON Patch
            </Typography>

            <Grid container spacing={4} sx={{ mb: 4 }}>
                <Grid item xs={12} md={4}>
                    <Paper sx={{
                        p: 4, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
                        borderRadius: 'var(--radius-lg)', textAlign: 'center',
                        backgroundColor: 'var(--surface)',
                        border: '1px solid var(--border)',
                        transition: 'box-shadow var(--duration-normal) var(--ease-default)',
                        '&:hover': { boxShadow: 'var(--shadow-lg)' },
                    }}>
                        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                            <Box sx={{ width: 64, height: 64, borderRadius: '50%', mb: 3, backgroundColor: 'var(--learn-bg-1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <MenuBookOutlinedIcon sx={{ fontSize: '30px', color: 'var(--learn-icon-1)' }} />
                            </Box>
                            <Typography sx={{ fontSize: 'var(--font-size-xl)', fontWeight: 700, color: 'var(--fg)', mb: 1.5 }}>Complete Documentation</Typography>
                            <Typography sx={{ color: 'var(--fg-muted)', mb: 3, flex: 1 }}>
                                Master JSON Patch with our comprehensive guide. Learn all RFC 6902 operations and best practices.
                            </Typography>
                            <Button href="/docs" sx={{
                                px: 3, py: 1.25, borderRadius: 'var(--radius-md)', fontWeight: 600,
                                fontSize: 'var(--font-size-base)', backgroundColor: 'var(--accent)',
                                color: 'var(--fg-on-accent)', textTransform: 'none',
                                display: 'inline-flex', alignItems: 'center', gap: 1,
                                boxShadow: '0 2px 6px rgba(59, 130, 246, 0.2)',
                                transition: 'background-color var(--duration-fast) var(--ease-default), box-shadow var(--duration-normal) var(--ease-default)',
                                '&:hover': { backgroundColor: 'var(--accent-hover)', boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)' }
                            }}>
                                <LibraryBooksOutlinedIcon sx={{ fontSize: '18px' }} />
                                Read the Docs →
                            </Button>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper sx={{
                        p: 4, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
                        borderRadius: 'var(--radius-lg)', textAlign: 'center',
                        backgroundColor: 'var(--surface)',
                        border: '1px solid var(--border)',
                        transition: 'box-shadow var(--duration-normal) var(--ease-default)',
                        '&:hover': { boxShadow: 'var(--shadow-lg)' },
                    }}>
                        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                            <Box sx={{ width: 64, height: 64, borderRadius: '50%', mb: 3, backgroundColor: 'var(--learn-bg-2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <LightbulbOutlinedIcon sx={{ fontSize: '30px', color: 'var(--learn-icon-2)' }} />
                            </Box>
                            <Typography sx={{ fontSize: 'var(--font-size-xl)', fontWeight: 700, color: 'var(--fg)', mb: 1.5 }}>Real-World Examples</Typography>
                            <Typography sx={{ color: 'var(--fg-muted)', mb: 3, flex: 1 }}>
                                See JSON Patch in action with practical examples like shopping carts and user updates.
                            </Typography>
                            <Button href="/examples" sx={{
                                px: 3, py: 1.25, borderRadius: 'var(--radius-md)', fontWeight: 600,
                                fontSize: 'var(--font-size-base)', backgroundColor: '#ec4899',
                                color: 'var(--fg-on-accent)', textTransform: 'none',
                                display: 'inline-flex', alignItems: 'center', gap: 1,
                                boxShadow: '0 2px 6px rgba(236, 72, 153, 0.2)',
                                transition: 'background-color var(--duration-fast) var(--ease-default), box-shadow var(--duration-normal) var(--ease-default)',
                                '&:hover': { backgroundColor: '#db2777', boxShadow: '0 4px 12px rgba(236, 72, 153, 0.3)' }
                            }}>
                                <RocketLaunchOutlinedIcon sx={{ fontSize: '18px' }} />
                                Try Examples →
                            </Button>
                        </Box>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper sx={{
                        p: 4, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
                        borderRadius: 'var(--radius-lg)', textAlign: 'center', backgroundColor: 'var(--surface)',
                        border: '1px solid var(--border)',
                        transition: 'box-shadow var(--duration-normal) var(--ease-default)',
                        '&:hover': { boxShadow: 'var(--shadow-lg)' },
                    }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                            <Box sx={{ width: 64, height: 64, borderRadius: '50%', mb: 3, backgroundColor: 'var(--learn-bg-1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <CodeOutlinedIcon sx={{ fontSize: '30px', color: 'var(--learn-icon-1)' }} />
                            </Box>
                            <Typography sx={{ fontSize: 'var(--font-size-xl)', fontWeight: 700, color: 'var(--fg)', mb: 1.5 }}>Language Guides</Typography>
                            <Typography sx={{ color: 'var(--fg-muted)', mb: 3, flex: 1 }}>
                                Use JSON Patch in JavaScript, Python, Go and Java, or compare it with JSON Merge Patch.
                            </Typography>
                            <Button href="/guides" sx={{ px: 3, py: 1.25, borderRadius: 'var(--radius-md)', fontWeight: 600, textTransform: 'none' }}>
                                Browse all guides →
                            </Button>
                            <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
                                <Button size="small" href="/guides/json-patch-in-javascript">JavaScript</Button>
                                <Button size="small" href="/guides/json-patch-in-python">Python</Button>
                                <Button size="small" href="/guides/json-patch-in-go">Go</Button>
                                <Button size="small" href="/guides/json-patch-in-java">Java</Button>
                                <Button size="small" href="/guides/json-patch-vs-json-merge-patch">Merge Patch</Button>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default LearningSection;
